import React from 'react';

const FeaturesPreview = () => {
  const features = [
    {
      title: 'Mood Tracking & Compatibility',
      description: 'Share your emotional state and energy levels privately. Our AI analyzes compatibility in real-time to suggest optimal moments for connection.',
      image: 'mood-tracker'
    },
    {
      title: 'AI Communication Hub',
      description: 'Express desires and boundaries through private input panels. AI mediates conversations with empathy, helping you find common ground.',
      image: 'communication-hub'
    },
    {
      title: 'Smart Scheduling',
      description: 'Coordinate intimate moments intelligently. The system considers both partners\' availability, mood, and preferences for perfect timing.',
      image: 'scheduler'
    }
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-foreground mb-4">
            Sophisticated Yet Approachable
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            See how couples are using LoveNudge to deepen their connection and navigate intimacy with confidence.
          </p>
        </div>

        {/* Features List */}
        <div className="space-y-24">
          {features?.map((feature, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Content */}
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <h3 className="font-heading text-2xl sm:text-3xl font-semibold text-foreground mb-4">
                  {feature?.title}
                </h3>
                <p className="text-lg text-muted-foreground mb-6">
                  {feature?.description}
                </p>
              </div>

              {/* Feature Preview */}
              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="relative rounded-xl overflow-hidden shadow-therapeutic-lg border border-border">
                  <div className="aspect-[4/3] bg-gradient-to-br from-primary/10 via-secondary/5 to-accent/10 flex items-center justify-center">
                    <div className="text-center p-8">
                      <div className="w-20 h-20 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center">
                        {index === 0 && (
                          <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        )}
                        {index === 1 && (
                          <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                          </svg>
                        )}
                        {index === 2 && (
                          <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        )}
                      </div>
                      <p className="text-sm text-muted-foreground font-caption">{feature?.image} interface preview</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesPreview;